import React from "react";
import { useSelector } from "react-redux";
import NavBar from "../components/NavBar";
import {
  SideMenu,
  SideMenuItem,
  SideMenuItemGroup,
} from "../components/SideMenu";

export default function Admin(props) {
  let { location, t } = props;
  const sidemenu = useSelector((state) => state.utilities.sidemenu);
  let routeGroup = {
    homepage: ["/"],
    registration: ["/organization-registration"],
    organizedMarketOperations: [
      "/offer-operations",
      "/market-results",
      "/offers-and-matches",
    ],
    marketOperations: [
      "/active-certificates",
      "/suspended-certificates",
      "/canceled-certificates",
      "/redemption-operations",
      "/redemption-operations-history",
      "/export-transactions",
      "/bilateral-agreements",
      "/bilateral-agreement-operations",
      "/gddk-operations",
      "/gddk-operations/production-data",
      "/gddk-operations/consumption-data",
    ],
    organizationConciliation: ["/organization-conciliation"],
    reconciliation: ["/reconciliation"],
    invoicing: ["/invoicing"],
    systemParameters: ["/system-parameters"],
    collaterals: ["/collateral-table"],
    collateralOperations: [
      "/intra-seance-collateral",
      "/invoice-colletarel-report",
    ],
  };
  const routeIsActive = (route) => {
    if (route === "homepage") {
      return location.pathname === "/";
    }
    return routeGroup[route].includes(location.pathname);
  };
  return (
    <div className="km__l--default-container">
      <NavBar user={{ name: "Admin" }} t={t} />
      <SideMenu>
        <SideMenuItemGroup
          icon="dashboard"
          label={t("ui.default.sideMenu.homepage")}
          isActive={routeIsActive("homepage")}
        >
          <SideMenuItem
            to="/"
            label={t("ui.default.sideMenu.homepage")}
            exact
          />
        </SideMenuItemGroup>
        <SideMenuItemGroup
          icon="registration"
          label={t("ui.default.sideMenu.registration")}
          isActive={routeIsActive("registration")}
        >
          <SideMenuItem
            to="/organization-registration"
            label={t("ui.default.sideMenu.organizationAndStationRegistration")}
          />
          <SideMenuItem
            to="/yekg-participation-list"
            label={t("ui.default.sideMenu.organizationYekgParticipationList")}
          />
          <SideMenuItem
            to="/yekg-commitment-status-list"
            label={t(
              "ui.default.sideMenu.organizationYekgCommitmentStatusList"
            )}
          />
        </SideMenuItemGroup>
        <SideMenuItemGroup
          icon="organized-market"
          label={t("ui.default.sideMenu.organizedMarketOperations")}
          isActive={routeIsActive("organizedMarketOperations")}
        >
          <SideMenuItem
            to="/offer-operations"
            label={t("ui.default.sideMenu.offerOperations")}
          />
          <SideMenuItem
            to="/offers-and-matches"
            label={t("ui.default.sideMenu.offersAndMatches")}
          />
          <SideMenuItem
            to="/market-results"
            label={t("ui.default.sideMenu.marketResults")}
          />
          <SideMenuItem
            to="/objections"
            label={t("ui.default.sideMenu.objections")}
          />
          <SideMenuItem
            to="/collateral-table"
            label={t("ui.default.sideMenu.collateral")}
          />
        </SideMenuItemGroup>
        <SideMenuItemGroup
          icon="certificates"
          label={t("ui.default.sideMenu.marketOperations")}
          isActive={routeIsActive("marketOperations")}
        >
          <SideMenuItem
            to="/active-certificates"
            label={t("ui.default.sideMenu.activeCertificates")}
          />
          <SideMenuItem
            to="/suspended-certificates"
            label={t("ui.default.sideMenu.suspendedCertificates")}
          />
          <SideMenuItem
            to="/canceled-certificates"
            label={t("ui.default.sideMenu.canceledCertificates")}
          />
          <SideMenuItem
            to="/export-transactions"
            label={t("ui.default.sideMenu.exportTransactions")}
          />
          <SideMenuItem
            to="/redemption-operations"
            label={t("ui.default.sideMenu.redemptionOperations")}
          />
          <SideMenuItem
            to="/redemption-operations-history"
            label={t("ui.default.sideMenu.redemptionOperationsHistory")}
          />
          <SideMenuItem
            to="/bilateral-agreements"
            label={t("ui.default.sideMenu.bilateralAgreements")}
          />
          <SideMenuItem
            to="/bilateral-agreement-operations"
            label={t("ui.default.sideMenu.bilateralAgreementOperations")}
          />
          <SideMenuItem
            to="/gddk-operations"
            label={t("ui.default.sideMenu.gddkOperations")}
          />
        </SideMenuItemGroup>
        <SideMenuItemGroup
          icon="reconcilliation"
          label={t("ui.default.sideMenu.reconciliation")}
          isActive={routeIsActive("reconciliation")}
        >
          <SideMenuItem
            to="/reconciliation"
            label={t("ui.default.sideMenu.reconciliation")}
          />
        </SideMenuItemGroup>
        <SideMenuItemGroup
          icon="refresh-ccw"
          label={t("ui.default.sideMenu.collateralOperations")}
          isActive={routeIsActive("collateralOperations")}
        >
          <SideMenuItem
            to="/intra-seance-collateral"
            label={t("ui.default.sideMenu.intraSeanceCollateral")}
          />
          <SideMenuItem
            to="/invoice-colletarel-report"
            label={t("ui.default.sideMenu.invoiceColletarelReport")}
          />
        </SideMenuItemGroup>
        <SideMenuItemGroup
          icon="invoicing"
          label={t("ui.default.sideMenu.invoicing")}
          isActive={routeIsActive("invoicing")}
        >
          <SideMenuItem
            to="/invoicing"
            label={t("ui.default.sideMenu.invoicing")}
          />
        </SideMenuItemGroup>
        <SideMenuItemGroup
          icon="parameters"
          label={t("ui.default.sideMenu.systemParameters")}
          isActive={routeIsActive("systemParameters")}
        >
          <SideMenuItem
            to="/system-parameters"
            label={t("ui.default.sideMenu.systemParameters")}
          />
        </SideMenuItemGroup>
        <SideMenuItem to="/run-jobs" label="JOB ÇALIŞTIR" />
      </SideMenu>
      <div
        className={`km__l--default-content-container ${
          sidemenu ? "km__l--default-content-container-is-sidemenu-active" : ""
        }`}
      >
        <div className="km__l--default-content">{props.children}</div>
      </div>
    </div>
  );
}
